import React from 'react';

import { FormControl, Grid, InputLabel, Select, MenuItem } from '@mui/material';
import { useApiGet } from '../../utils/httpClient';
import { getAllReports } from '../../endpoints/reportsTs';

export default function DocumentTypeSelector({ type, handleTypeSelect }) {
  const { data } = useApiGet(['doc-type-selector'], getAllReports, {
    enabled: true,
    retry: 1,
  });

  const reports = Array.isArray(data) ? data : [];

  return (
    <Grid container>
      <Grid item xs={12}>
        {reports.length > 0 && (
          <FormControl fullWidth>
            <InputLabel id="report-select-label">Type</InputLabel>
            <Select
              labelId="doc-type-label"
              id="doc-type-select"
              value={type}
              label="Type"
              onChange={(event) => handleTypeSelect(event.target.value)}
            >
              {reports.map((docType) => (
                <MenuItem key={docType.id} value={docType.id}>
                  {docType.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Grid>
    </Grid>
  );
}
